// extracted by mini-css-extract-plugin
export default {"container":"SubmitSuccessLink_container__-vbFC","content":"SubmitSuccessLink_content__rXRN4"};